import { AiSurface } from '@/components/ui/ai-surface';

/**
 * The one-line notice shown where the AI proposal review route lands an
 * engagement that has no IV&V module (`?from=proposals` on Discovery ->
 * Findings or on Selection). It says why the reader is here and not on the
 * IV&V review queue. Same `AiSurface` status treatment as the activity
 * strip above every engagement screen.
 */
export function ReviewRedirectNotice({ target }: { target: 'discovery' | 'selection' }) {
  return (
    <AiSurface
      role="status"
      aria-live="polite"
      data-testid="review-redirect-notice"
      className="mb-3 rounded-card px-3 py-2 text-body-sm"
    >
      {target === 'discovery'
        ? 'This engagement has no IV&V review queue. AI-proposed discovery evidence is reviewed here, in Findings.'
        : 'This engagement has no IV&V review queue. Its requirements, and any suggestions, are reviewed here, in Selection.'}
    </AiSurface>
  );
}
